function parseQuery(str) {
    if (str.charAt(0) === '?') {
        str = str.substring(1, str.length);
    }

    function extractParams(i) {
        const params = i.split('=');

        if (params && params.length) {
            const item = {};
            item[params[0]] = params[1];
            return item;
        }
        return true;
    }

    const parts = str
        .split('&')
        .map(extractParams);
    return parts;

}

module.exports = parseQuery;



// WEBPACK FOOTER //
// ./src/js/parse-query.js